// jQuery(document).ready(function($){
//   $(".custom-contact-form-container-header").on("click", function(){
//     $(this).toggleClass("active");
//     $(".custom-contact-form-container-body").slideToggle();
//   });
// });

document.addEventListener("DOMContentLoaded", function() {
  document.querySelector(".custom-contact-form-container-header").addEventListener("click", function() {
    this.classList.toggle("active");

    const formBody = document.querySelector(".custom-contact-form-container-body");
    if (formBody.style.display === "none" || formBody.style.display === "") {
      formBody.style.display = "block";
      formBody.style.maxHeight = formBody.scrollHeight + "px";
    } else {
      formBody.style.display = "none";
    }
  });
});
